class LogService {
  constructor(_contexts = [], _parent = null) {
    this._contexts = _contexts;
    this._parent = _parent;
  }
  createChild(name) {
    return new LogService([
      ...this._contexts,
      name
    ], this);
  }
  info(message, ...payload) {
    console.log(`${this._contexts.length && this._contexts.map((context) => `[${context}]`).join(" ") + " " || ""}${message}`);
  }
  error(message, ...payload) {
    console.error(`${this._contexts.length && this._contexts.map((context) => `[${context}]`).join(" ") + " " || ""}${message}`);
  }
  trace(message, ...payload) {
    this.info(message, ...payload);
  }
  debug(message, ...payload) {
    this.info(message, ...payload);
  }
}

export { LogService };
//# sourceMappingURL=index.es.js.map
